// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1LJWV","label":"Completed_label__2GKmc"};